import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
  selectMeteorologyAgroWBSequentialDVTriggerRequest,
  setGroup,
  setLocation,
  setPeriodEnd,
  setPeriodStart,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import { store } from 'redux/store';
import {
  addDays, format, fromUnixTime, min, parse,
} from 'date-fns';
import useOptions from './useOptions';

const PERIOD_INTERVAL = 15;

export default function useRedirectFromMap() {
  const { state } = useLocation();
  const { options } = useOptions();
  const [shouldTriggerRequest, setShouldTriggerRequest] = useState(false);
  const triggerRequest = useSelector(selectMeteorologyAgroWBSequentialDVTriggerRequest);

  useEffect(() => {
    if (!state || !options) return;

    const maxEndDate = fromUnixTime(options.endDate);
    const startDate = state.periodStart
      ? parse(state.periodStart, 'yyyy-MM-dd', new Date())
      : undefined;
    const endDate = startDate
      ? min([maxEndDate, addDays(startDate, PERIOD_INTERVAL)])
      : undefined;
    const periodEnd = endDate ? format(endDate, 'yyyy-MM-dd') : undefined;

    setShouldTriggerRequest(true);
    store.dispatch(setGroup(state.groupId));
    store.dispatch(setLocation(state.locationId));
    store.dispatch(setPeriodStart(state.periodStart));
    store.dispatch(setPeriodEnd(periodEnd));
    window.history.replaceState({}, '');
  }, [state, options]);

  useEffect(() => {
    if (shouldTriggerRequest && triggerRequest) {
      triggerRequest();
      setShouldTriggerRequest(false);
    }
  }, [shouldTriggerRequest, triggerRequest]);
}
